// React
import React from 'react'
// Components
import ConsciousApps from '../Footer/ConsciousApps'
import HomeButton from '../Nav/HomeButton'
import Stripe from './Stripe'

export default class CompleteAccess extends React.Component {

	constructor(props) {
		super(props)
		this.state = { page: 1 }
	}

	componentDidMount() {
		window.scrollTo(0, 0)
	}

	setPage = () => this.setState({ page: 2 })

	render() {
		const { page } = this.state
		if (page === 1) {
			return (
				<div className='capps-container'>
					<HomeButton {...this.props} />
					<center><div className='capps-moon' /></center>
					<div className='capps-header'>Complete Access</div>
					<div className='capps-height-10' />
					<div className='capps-text'>
						A one-time payment of USD $9.99 unlocks the following features of the Moon Sign App for life:
						<ul>
							<li>Unlimited contacts</li>
							<li>No advertisements</li>
							<li>Ongoing customer support</li>
						</ul>
						We look forward to having you on board!
						<div className='capps-height-10' />
						{process.env.REACT_APP_ENV === 'web' && <Stripe {...this.props} />}
						<div className='capps-height-10' />
						<div className='capps-footer'><span className='capps-link' onTouchTap={() => this.setPage()}>I have additional questions</span></div>
					</div>
				</div>
			)
		}
		return (
			<div className='capps-container'>
				<HomeButton {...this.props} />
				<center><div className='capps-moon' /></center>
				<div className='capps-header'>Complete Access</div>
				<div className='capps-height-10' />
				<div className='capps-text'>
					If you have any questions before making a purchase, please don’t hesitate to reach out via our in-app customer service by clicking the <strong>support by conscious apps</strong> icon on the bottom of your screen.
					<div className='capps-height-10' />
					We are commmitted to providing you the best possible app experience. If you are unhappy with your purchase for any reasons, you may request a full refund in accordance with our <span onTouchTap={() => window.open('https://www.consciousapps.com/terms', '_system')} className='capps-link'>Terms of Service</span>.
					<div className='capps-height-10' />
					{process.env.REACT_APP_ENV === 'web' && <Stripe {...this.props} />}
					<div className='capps-height-10' />
					Warm regards,
					<div className='capps-signature' />
					<div className='capps-footer left'>
						Martin Adams, Conscious Apps Inc.<br />
						Developer of the <span className='capps-link' onTouchTap={() => this.props.redux.nav.setPage('')}>Moon Sign App</span>
					</div>
				</div>
				<ConsciousApps {...this.props} />
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Components/Payment/CompleteAccess.js